import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiPartnerQualifiers extends Layout {
    buttonDisableAll: Button;
    buttonEnableAll: Button;
    labelT: Label;
    sourceEdiPartnerCodeDetail: DataSource;
    tablePartnerQualifiers: Table;
}
